import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRef } from "react";
import emailjs from "emailjs-com";
// import Header from "./Header";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
function Psychotherapy() {
  const psychotherapyTopics = [
    "Self - Exploration & Development",
    "Trauma & Grief",
    "Anxiety, Depression",
    "Relationships",
    "Pre-marital & Marital Counseling",
    "Parenting",
  ];

  const location = useLocation();
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_wqxvvyb", // ✅ Your Service ID
        "template_qkofn8e", // ✅ Your Template ID
        form.current,
        "vwNB5WM_83ykdcls0", // ✅ Your Public Key
      )
      .then(
        () => {
          alert("✅ Thank you! Your form has been submitted.");
          form.current.reset();
        },
        (error) => {
          alert("❌ Something went wrong. Please try again.");
          console.error(error.text);
        },
      );
  };

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <>
      <Container className="therapy mb-5">
        {/* individual */}
        <>
          <Row id="psychotherapy">
            <h4 className="text-center fw-bold">
              Psychotherapy at ScopeWithin
            </h4>
            <p className="text-center fst-italic grey">
              Trauma-informed and Neurodivergence Inclusive Support for South
              Asian Individuals and Couples Globally*
            </p>
          </Row>
          <Row className="justify-content-center g-4 mb-5">
            {psychotherapyTopics.map((topic, index) => (
              <Col key={index} className="d-flex justify-content-center">
                <div className="topic-box d-flex align-items-center justify-content-center text-center">
                  {topic}
                </div>
              </Col>
            ))}
          </Row>
          <Row>
            <p className="grey fst-italic">
              *therapy sessions are open for the age group 25-45 years. <br />
              *therapy sessions are available via video call only.
            </p>
          </Row>
        </>
      </Container>
    </>
  );
}

export default Psychotherapy;
